// import { FinanceInterstate, LeaseInterstate } from '@makemydeal/dr-dash-components';
import LeaseInterstate from '../../terms/Lease.interstate';
import FinanceInterstate from '../../terms/Finance.interstate';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import type { OfferType } from '@makemydeal/dr-platform-types';
import { FINANCE, LEASE } from '@makemydeal/dr-platform-types';
import { useSelector } from 'react-redux';

const CreditDecisionTerms = () => {
    const currentOfferType: OfferType = useSelector(offerReduxSelectors.getCurrentOfferType);

    if (currentOfferType === FINANCE) {
        return <FinanceInterstate isInsideSlideOut={true} />;
    }

    if (currentOfferType === LEASE) {
        return <LeaseInterstate isInsideSlideOut={true} />;
    }

    return null;
};

export default CreditDecisionTerms;
